
export default {
  name: 'CoreView',
  metaInfo() {
    return {
      title: 'SiTrendi by Nash Technology from PT Nash Interaksi Semesta',
    }
  },
}
